module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/public_sciences/2-e74a9ff9d3c0b36405c19cab8f65238b.jpg";